// extracted by mini-css-extract-plugin
export default {"thank":"index_thank_5UhTP","thankTitle":"index_thankTitle_DbinV","thankBox":"index_thankBox_n6mQR"};